import { SeoHead } from "@/components/SeoHead"
import { MarketingLayout } from "@/components/marketing/MarketingLayout"
import { Section, Eyebrow } from "@/components/marketing/sections/Section"
import { SavvyCalEmbed } from "@/components/marketing/SavvyCalEmbed"
import { track } from "@/lib/analytics"
import type { PageProps } from "@/types/inertia"

type BookProps = PageProps<{
  name: string
  email: string
  savvycalLink: string
  savvycalUrl: string
}>

export default function Book({ name, email, savvycalLink, savvycalUrl }: BookProps) {
  return (
    <MarketingLayout>
      <SeoHead
        title="Book your Fit Call"
        description="Book your Podcast Growth Fit Call with FullCast."
        noindex
      />

      <Section containerClassName="max-w-3xl">
        <Eyebrow>You're a great fit</Eyebrow>
        <h1 className="display-2 mt-4">Book your Podcast Growth Fit Call</h1>
        <p className="mt-5 text-lg text-ink-body">
          Pick a time that works for you. We'll look at your offer, audience, and
          authority position, and whether a podcast-led relationship strategy
          makes sense for your business.
        </p>

        <div className="mt-10">
          <SavvyCalEmbed
            link={savvycalLink}
            url={savvycalUrl}
            name={name}
            email={email}
            onBooked={() => track("Fit Call Booked")}
          />
        </div>

        <p className="mt-6 text-sm text-ink-muted">
          Prefer a new tab?{" "}
          <a href={savvycalUrl} target="_blank" rel="noopener noreferrer">
            Open the booking page directly
          </a>
          .
        </p>
      </Section>
    </MarketingLayout>
  )
}
